//巴西葡萄牙语
export default {
  Login: {
    Title: "Faça login na sua conta",
    describe: "Por favor, faça login ou crie uma conta para começar.",
    Google: "Continuar com o Google",
    Apple: "Continuar com o Apple",
    or: "OU",
    Emailplaceholder: "Endereço de e-mail",
    Passwordplaceholder: "Senha",
    Login: "Entrar",
    forgot: "Esqueceu a senha?",
    notAccount: "Não tem uma conta Fineshare?",
    Signup: "Cadastrar-se",
    InvalidEmail: "Formato de e-mail inválido.",
    InvalidPassword: "A senha deve ter pelo menos 6 caracteres.",
    loading: "Carregando..",
    login: "entrar",
    errorText:
      "Falha no login, por favor, verifique seu nome de usuário e senha",
  },
  signup: {
    Title: "Crie sua conta",
    describe: "Crie sua conta Fineshare em segundos.",
    Google: "Cadastrar-se com o Google",
    Apple: "Cadastrar-se com o Apple",
    or: "OU",
    Emailplaceholder: "Digite o endereço de e-mail",
    Passwordplaceholder: "Digite uma senha de 6 dígitos",
    Already: "Já tem uma conta?",
    Login: "Entrar",
    By: "Ao criar uma conta, concordo que li e aceitei a",
    Privacy: "Política de Privacidade",
    Terms: "Termos de Uso.",
    and: "e",
    signupText: "Criar sua conta",
    InvalidEmail: "Formato de e-mail inválido.",
    InvalidPassword: "A senha deve ter pelo menos 6 caracteres.",
    loading: "Carregando..",
    passwordError: "O endereço de e-mail já foi registrado",
    again:
      "Você está fazendo muitas tentativas, por favor, tente novamente mais tarde",
    Registration: "Falha no registro, por favor, verifique seu e-mail e senha.",
    hasRegistered: "O endereço de e-mail já foi registrado",
  },
  Home: {
    Welcome: "Bem-vindo ao Centro de Contas Fineshare",
  },
};
